import CareerBuilderEdgeAdvanceSearch from '../types/ICareerBuilderEdgeAdvanceSearch';

export const processCareerBuilderEdgeFiltersResponse = (
  response: any
): CareerBuilderEdgeAdvanceSearch => {
  const filterResponse: CareerBuilderEdgeAdvanceSearch = {
    searchPattern: '',
    AcademicDiscipline: [],
    JobTitle: [],
    CurrentEmployer: [],
    ContactInfo: [],
    CurrentlyEmployed: [],
    City: [],
    Country: [],
    DegreeLevel: [],
    Industry: [],
    PreviousEmployer: [],
    Skill: [],
    HasResume: [],
    Source: [],
    State: [],
    DesiredJobType: [],
    WorkStatus: [],
    EdgeScore: [],
    ResumeModified: [],
    YearsOfExperience: [],
    zipcode: '',
    jobTitle: '',
    WillingToRelocate: [],
    SecurityClearance: [],
  };
  response.map((item: any) => {
    const fieldName = item.Name.replace('V3', '')
      .replace('V2', '')
      .replace('Carotene', '')
      .split(/(?=[A-Z])/)
      .join(' ');
    if (fieldName === 'Academic Discipline') {
      filterResponse.AcademicDiscipline = item.FacetItem;
    }
    if (fieldName === 'Current Employer') {
      filterResponse.CurrentEmployer = item.FacetItem;
    }
    if (fieldName === 'Contact Info') {
      filterResponse.ContactInfo = item.FacetItem;
    }
    if (fieldName === 'Title') {
      filterResponse.JobTitle = item.FacetItem;
    }
    if (fieldName === 'City') {
      filterResponse.City = item.FacetItem;
    }
    if (fieldName === 'Country') {
      filterResponse.Country = item.FacetItem;
    }
    if (fieldName === 'Currently Employed') {
      filterResponse.CurrentlyEmployed = item.FacetItem;
    }
    if (fieldName === 'Degree Level') {
      filterResponse.DegreeLevel = item.FacetItem;
    }
    if (fieldName === 'Industry') {
      filterResponse.Industry = item.FacetItem;
    }
    if (fieldName === 'Previous Employer') {
      filterResponse.PreviousEmployer = item.FacetItem;
    }
    if (fieldName === 'Skill') {
      filterResponse.Skill = item.FacetItem;
    }
    if (fieldName === 'Source') {
      filterResponse.Source = item.FacetItem;
    }
    if (fieldName === 'Has Resume') {
      filterResponse.HasResume = item.FacetItem;
    }
    if (fieldName === 'State') {
      filterResponse.State = item.FacetItem;
    }
    if (fieldName === 'Desired Job Type') {
      filterResponse.DesiredJobType = item.FacetItem;
    }
    if (fieldName === 'Work Status') {
      filterResponse.WorkStatus = item.FacetItem;
    }
    if (fieldName === 'Years Of Experience') {
      filterResponse.YearsOfExperience = item.FacetItem;
    }
    if (fieldName === 'Edge Score') {
      filterResponse.EdgeScore = item.FacetItem;
    }
    if (fieldName === 'Resume Modified') {
      filterResponse.ResumeModified = item.FacetItem;
    }
    if (fieldName === 'Willing To Relocate') {
      filterResponse.WillingToRelocate = item.FacetItem;
    }
    if (fieldName === 'Security Clearance') {
      filterResponse.SecurityClearance = item.FacetItem;
    }
  });
  return filterResponse;
};
